import { Content } from '@prismicio/client';
import { Simplify } from '../../../../../../prismicio-types';

import styles from './aboutUsHeroCards.module.scss';
import { OptimizedPrismicImage } from '@/components';

interface AboutUsHeroCardsProps {
  data: Simplify<Content.HeroSliceAboutUsPrimary>;
  isVisible: boolean;
}

export const AboutUsHeroCards = ({
  data,
  isVisible,
}: AboutUsHeroCardsProps) => {
  const isVisibleStyles = isVisible ? styles.isVisible : '';
  return (
    <article className={styles.cards}>
      <div className={styles.first_column}>
        <div className={`${styles.first_photo_wrapper} ${isVisibleStyles}`}>
          <OptimizedPrismicImage field={data.first_card_photo} />
        </div>
        <div className={`${styles.loan} ${isVisibleStyles}`}>
          <div className={styles.loan_value}>
            <span>{data.loan_card_value}</span>
            <OptimizedPrismicImage field={data.loan_card_icon} />
          </div>
          <p className={styles.loan_text}>{data.loan_card_text}</p>
        </div>
      </div>
      <div className={`${styles.equity} ${isVisibleStyles}`}>
        <div className={styles.equity_heading}>
          <span>{data.equity_card_value}</span>
          <span>{data.equity_card_text}</span>
        </div>
        <div className={styles.equity_image}>
          <OptimizedPrismicImage field={data.equity_card_image} />
        </div>
      </div>
      <div className={`${styles.second_photo_wrapper} ${isVisibleStyles}`}>
        <OptimizedPrismicImage field={data.last_card_photo} />
      </div>
    </article>
  );
};
